import Vue from 'vue'
import Router from 'vue-router'
import axios from 'axios'
import store from '../store'
import routerConfig from './router.config'
import { misApiHost, misSSOUrl, apiHost, otpHost } from '../config/env.conf'
import { addSources } from 'utils/lazyLoad';
Vue.use(Router)

const router = new Router({
    mode: 'hash',
    routes: routerConfig
})
let isMisPage = false

const lazyLoadUrls = ['//awp-assets.meituan.net/hfe/fep/6b4b3a87958e7f26a37bfa9206f0cac1/notpxigua.min.js',
    '//awp-assets.meituan.net/hfe/fep/9d93eed949585a53c7c19106e292e800/xiguaStyle.52e08ec97b8608c6c8861175e2cf58da.css',
    '//awp-assets.meituan.net/hfe/fep/ee42594ba27c859a9d2ef2b44be15fc3/notpecharts.min.js']

function routeBeforeHooks(to, from, next) {
    isMisPage = to.meta.isMis
    baiduAnalytics(to);
    store.dispatch('updatePageAccountType', isMisPage ? 'mis' : 'biz')
    // 如果是mis账号操作
    if (isMisPage) {
        if (to.meta.noAuth) {
            next()
            return
        }
        store.dispatch('getMisUser').then((data) => {
            next()
        }).catch(() => {
            // 未登录
            const url = encodeURIComponent(window.location.href)
            const settoken = `${location.protocol}${misApiHost}/tbms/api/v1/settoken?continue=${url}`
            const service = encodeURIComponent(settoken)
            window.location.href = `${misSSOUrl}/auth?service=${service}`
        })
    } else {
        //
        if (to.meta.noUser) {
            next();
            return;
        }
        //
        store.dispatch('getUser').then((data) => {
            if (to.meta.noAuth) {
                next()
                return
            }
            if (to.path === '/' || store.state.sfCustoms.check(to.path)) {
                next()
            } else {
                next({ name: 'unauthorized' });
            }
        }).catch(() => {
            store.dispatch('updateBeforeLogin', to)
            next({ path: '/login' })
        })
    }
}
//
router.beforeEach((to, from, next) => {
    // ...
    if (!window.extraResourcesLoaded) {
        if (to.name && /home$/i.test(to.name) || (to.meta && to.meta.src && to.meta.src.includes(otpHost))) {
            routeBeforeHooks(to, from, next);
        } else {
            addSources(lazyLoadUrls).then(function () {
                window.xigua.install(window.Vue);
                routeBeforeHooks(to, from, next);
                window.extraResourcesLoaded = true;
            }
            ).catch(err => {
                console.error(err);
            });
        }
    } else {
        routeBeforeHooks(to, from, next);
    }
})

axios.interceptors.request.use(function (config) {
    // Do something before request is sent
    // if role is bd, then switch api to sankuai domain
    if (config.params && config.params.apiRole === 'auto' && isMisPage) {
        config.url = config.url.replace(apiHost, misApiHost)
    }
    if (config.params && config.params.apiRole) {
        delete config.params.apiRole
    }
    return config
}, function (error) {
    // Do something with request error
    return Promise.reject(error)
})

window.router = router
export default router

function baiduAnalytics(to) {
    if (window._hmt) {
        window._hmt.push(['_trackPageview', '/notp' + to.fullPath]);
    }
}


// WEBPACK FOOTER //
// ./src/router/index.js